/* global Turbolinks */
Turbolinks.start()

import 'default'

import 'hof'
